// @flow
import React ,{useEffect} from 'react';
import { chunk, isEmpty } from 'lodash';
import classNames from 'classnames';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { HomeActions } from 'modules/home/actions';
import MediaQuery from 'react-responsive';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { RouteNames } from 'router';
import { Banner } from 'components/atoms/banner';
import { MobileFooterLinks } from 'components/atoms/mobileFooterLinks';
import { Quote } from 'components/atoms/quote';
import { SocialLinks } from 'components/molecules/socialLinks';
import { FooterMenu } from 'components/molecules/footerMenu';
import {CustomFooterMenu } from 'components/molecules/customFooterMenu';
import { useViewport } from 'components/templates/viewportProvider';
import type { SiteSettings } from 'types/common';
import { HomeSelector } from 'modules/home/selector';
import { CmsPagesSelector } from 'modules/cmsPages/selector';
// eslint-disable-next-line no-unused-vars
import styles from './styles.scss';
import FooterLink from 'components/atoms/footerLink/footerLink';
// TODO:
type Props = {
  siteSettings: SiteSettings,
};

const FooterSection = (props: Props) => {
  const { height, isMobile } = useViewport();
  const { footerLinks,getHeaderData,
    getheaderData, } = props;
  const { siteSettings, footerLink } = props.data;
  useEffect(() => {
    getHeaderData();
  }, []);
  if (!siteSettings) {
    return null;
  }
  const containerClass = classNames('footer-container', {
    // 'normal-scroll': isMobile === false,
  });

  const contentClass = classNames('footer-menu-container', {
    'normal-scroll': isMobile === false,
  });
  const footerBanner = isMobile
    ? siteSettings.settings.mobileFooterBannerUrl
    : siteSettings.settings.footerBannerUrl;
  const thumbNailUrl = siteSettings.settings.thumbNailFooterBannerUrl;

  let footerInfoLink = chunk(footerLink, footerLink.length / 2 + 0.5);

  const getFooterLinks = () => {
    return {
      first: [
        !isEmpty(footerLinks.homes)
          ? { prefix: ' ', title: 'Homes', link: RouteNames.homes }
          : {},
        // { prefix: ' ', title: 'Rentals', link: RouteNames.rentals },
        !isEmpty(footerLinks.restaurants)
          ? { prefix: ' ', title: 'Restaurants', link: RouteNames.restaurants }
          : {},
        !isEmpty(footerLinks.musicData)
          ? {
              prefix: ' ',
              title: 'Music & Events',
              link: RouteNames.musicEvents,
            }
          : {},
        isMobile && !isEmpty(footerLinks.workspace)
          ? { prefix: ' ', title: 'Workcations', link: RouteNames.workcations }
          : {},
        isMobile && !isEmpty(footerLinks.landCraft)
          ? { prefix: ' ', title: 'Landcraft', link: RouteNames.landCraft }
          : {},
      ],
      second: [
        // { prefix: ' ', title: 'Resorts', link: RouteNames.resorts },
        !isEmpty(footerLinks.workspace)
          ? { prefix: ' ', title: 'Workcations', link: RouteNames.workcations }
          : {},
        !isEmpty(footerLinks.landCraft)
          ? { prefix: ' ', title: 'Landcraft', link: RouteNames.landCraft }
          : {},
        // { prefix: ' ', title: 'Store', link: RouteNames.stores },
        // { prefix: ' ', title: 'Studio', link: RouteNames.architectureDesign },
      ],
      static: [
        !isEmpty(footerLinks.aboutData)
          ? { title: 'About', link: RouteNames.about }
          : {},
        !isEmpty(footerLinks.careerData)
          ? { title: 'Careers', link: RouteNames.careers }
          : {},
        // { title: 'Contact', link: RouteNames.contact },
        // { title: 'Blog', link: '/' },
      ],
      homes: [
        // { prefix: 'Homes in', title: 'Bangalore', link: RouteNames.homes },
        // { prefix: 'Homes in', title: 'Pune', link: RouteNames.homes },
        // { prefix: 'Homes in', title: 'Hyderabad', link: RouteNames.homes },
        // { prefix: 'Homes in', title: 'Mumbai', link: RouteNames.homes },
        // { prefix: 'Homes in', title: 'Chennai', link: RouteNames.homes },
      ],
      rentals: [
        // {
        //   prefix: 'Rental Homes in',
        //   title: 'Bangalore',
        //   link: RouteNames.rentals,
        // },
        // { prefix: 'Rental Homes in', title: 'Pune', link: RouteNames.rentals },
        // {
        //   prefix: 'Rental Homes in',
        //   title: 'Hyderabad',
        //   link: RouteNames.rentals,
        // },
        // {
        //   prefix: 'Rental Homes in',
        //   title: 'Mumbai',
        //   link: RouteNames.rentals,
        // },
        // {
        //   prefix: 'Rental Homes in',
        //   title: 'Chennai',
        //   link: RouteNames.rentals,
        // },
      ],
      projects: [
        {
          prefix: 'New Projects in',
          title: 'Hyderabad',
          link: RouteNames.homes,
        },
        { prefix: 'New Projects in', title: 'Mumbai', link: RouteNames.homes },
        { prefix: 'New Projects in', title: 'Chennai', link: RouteNames.homes },
      ],
      events: [
        {
          prefix: 'Upcoming Events in',
          title: 'Hyderabad',
          link: RouteNames.musicEvents,
        },
        {
          prefix: 'Upcoming Events in',
          title: 'Mumbai',
          link: RouteNames.musicEvents,
        },
        {
          prefix: 'Upcoming Events in',
          title: 'Chennai',
          link: RouteNames.musicEvents,
        },
      ],
    };
  };

  const links = getFooterLinks();

  return (
    <div
      className={'footer-section'}
      // style={!isMobile ? { height } : {}}
      id={'te-links'}
    >
      <div className={containerClass}>
        <Banner
          thumbNailUrl={thumbNailUrl}
          imageUrl={footerBanner}
          fillHeight={false}
          fillWidth={true}
          containerClassName={'footer-banner-container'}
        />
         
        <Row className={'footer-content'}>
          <Col md={4} xs={11}>
            <Quote
              title={siteSettings.settings.footerContent}
              author={siteSettings.settings.author}
            />
          </Col>
          <MediaQuery minDeviceWidth={768}>
            <Col md={{ span: 6, offset: 2 }} className={contentClass}>
              <Row className={'footer-section-menu'}>
                <Col md={4}>
                  <FooterMenu links={links.first} type={'big'} />
                </Col>
                <Col md={4}>
                  <FooterMenu links={links.second} type={'big'} />
                </Col>
                <Col md={4}>
                  <FooterMenu links={links.static} type={'big'} />
                  { <CustomFooterMenu links={getheaderData?.customLinks} type={'big'} />  }
                </Col>
                <Col md={4}>
             
                </Col>
              </Row>
              <Row className={'footer-section-menu'}>
                {footerInfoLink.map((item, id) => {
                  return <FooterLink link={item} prop={props} />;
                })}
              </Row>
            </Col>
          </MediaQuery>
          {/*<Col md={4}>*/}
          {/*  <FooterMenu links={links.rentals} type={'small'} />*/}
          {/*</Col>*/}
          {/*<Row className={'footer-section-menu'}>*/}
          {/*  <Col md={4}>*/}
          {/*    <FooterMenu links={links.projects} type={'small'} />*/}
          {/*  </Col>*/}
          {/*  <Col md={4}>*/}
          {/*    <FooterMenu links={links.events} type={'small'} />*/}
          {/*  </Col>*/}
          {/*</Row>*/}
        </Row>
      </div>
      {siteSettings && siteSettings.social && (
        <MediaQuery minDeviceWidth={576}>
          <div className={'copyright-container'}>
            <Row>
              <Col md={{ span: 6, offset: 6 }}>
                <SocialLinks links={siteSettings.social} />
              </Col>
            </Row>
          </div>
        </MediaQuery>
      )}
      <MediaQuery maxDeviceWidth={575.98}>
        <div className={'footer-links-mobile'}>
          <div className={'copyright-container'}>
            <Row>
              <Col xs={7} md={4}>
                <FooterMenu links={links.first} type={'small'} />
              </Col>
              <Col xs={5} md={4}>
                <FooterMenu links={links.static} type={'small'} />
                { <CustomFooterMenu links={getheaderData?.customLinks} type={'small'} />  }
              </Col>

              <Col md={{ span: 6, offset: 6 }}>
                <Row className={'footer-section-menu'}>
                  {footerInfoLink.map((item, id) => {
                    return <FooterLink link={item} prop={props} />;
                  })}
                </Row>
                {/*<MobileFooterLinks links={[...links.first, ...links.static]} />*/}
               
                <SocialLinks links={siteSettings.social} />
              </Col>
            </Row>
          </div>
        </div>
      </MediaQuery>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    footerLinks: HomeSelector.showOfferingPages(state),
    getheaderData: HomeSelector.getHeaderData(state),
  };
};

const mapDispatchToProps = dispatch => {
  const { getHeaderData } = HomeActions;
  return bindActionCreators(
    {
      getHeaderData,
    },
    dispatch
  );
};
const connectedComponent = connect(mapStateToProps, mapDispatchToProps)(FooterSection);

export default withRouter(connectedComponent);
